// extracted by mini-css-extract-plugin
export default {"wrapper":"Tabs_wrapper__r4y8K","item":"Tabs_item__QOh46","line":"Tabs_line__M-rzK","container":"Tabs_container__3ovuc","block":"Tabs_block__iZrl4","active":"Tabs_active__uGUKx"};